export default "/static/033099272ee43aaa.svg"